// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"68":"views-users","459":"layouts-default-index","730":"views-report","821":"views-institutions","843":"views-gameGroup"}[chunkId] || chunkId) + "." + {"68":"3036b244","197":"5741adab","459":"896ab4b9","674":"13b0dc17","730":"4ed6b49c","821":"f07e80e9","843":"85efa79c"}[chunkId] + ".js";
};